import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { PointMaintAddComponent } from "./point-maint-add/point-maint-add.component";
import { PointMaintEditComponent } from "./point-maint-edit/point-maint-edit.component";
import { DataService_PBISMaintenance } from "./shared/data.service";

@Component({
	selector: "app-pbismaintenance",
	templateUrl: "./pbismaintenance.component.html",
	styleUrls: ["./pbismaintenance.component.css"],
})
export class PBISMaintenanceComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private PBISService: DataService_PBISMaintenance,
		private dialogService: DialogService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		// this.loadSchools();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	// SchoolLoading: any = true;
	SchoolID: any;
	lstSchool: any = [];

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPointsItem: any;
	lstPointsItem: any = [];

	//Filter lists
	lstPointsCategoryDesc: any = [];
	lstPointsCategoryTypeDesc: any = [];
	lstActiveDesc: any = [];
	lstUseInClassRoomDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "PointsItemDesc", header: "Point" },
		{ field: "PointsCategoryDesc", header: "Category" },
		{ field: "PointsCategoryTypeDesc", header: "Category Type" },
		{ field: "PointsItemValue", header: "Value" },
		{ field: "ActiveDesc", header: "Active" },
		{ field: "UseInClassRoomDesc", header: "Use In Classroom" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	// loadSchools(){
	//   this.SchoolLoading = true;

	//   var result = this.schoolService.loadSchoolList("");
	//   result.subscribe(
	//     response => {
	//       this.lstSchool = response;
	//       this.SchoolID = this.lstSchool[0].SchoolID;

	//       this.SchoolLoading = false;

	//       this.loadPointsItem();
	//     },
	//     error => {
	//       this.SchoolLoading = false;
	//     }
	//   )
	// }

	loadPointsItem() {
		this.errorMessage = "";

		this.loading = true;

		var result = this.PBISService.PBISPointItemSelectFullInfoList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstPointsItem = response;

				//Load Data Filter Lists
				this.lstPointsCategoryDesc = Array.from(new Set(this.lstPointsItem.map((item: any) => item.PointsCategoryDesc))).sort();
				this.lstPointsCategoryTypeDesc = Array.from(new Set(this.lstPointsItem.map((item: any) => item.PointsCategoryTypeDesc))).sort();
				this.lstActiveDesc = Array.from(new Set(this.lstPointsItem.map((item: any) => item.ActiveDesc))).sort();
				this.lstUseInClassRoomDesc = Array.from(new Set(this.lstPointsItem.map((item: any) => item.UseInClassRoomDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadPointsItem();
	}

	//Custom Button Methods
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(PointMaintAddComponent, {
			header: "Add Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPointsItem();
			}
		});
	}

	onEdit() {
		this.errorMessage = "";

		var ref = this.dialogService.open(PointMaintEditComponent, {
			header: "Edit Point",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SchoolID: this.SchoolID,
				PointsItemID: this.SelectedPointsItem.PointsItemID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadPointsItem();
			}
		});
	}

	onToggle() {
		if (this.SelectedPointsItem == undefined) {
			this.errorMessage = "Select a point to toggle";
			return;
		}

		var result = this.PBISService.PBISPointItemToggle(this.SelectedPointsItem.PointsItemID, this.SelectedPointsItem.Active == 1 ? 0 : 1);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadPointsItem();

					this.isProcessing = false;
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not toggle the point.",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadPointsItem();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedPointsItem == undefined) {
			this.errorMessage = "Select a point to delete";
			return;
		}

		this.isProcessing = true;

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Do you want to delete this point type? This will delete and undo all of the transactions that used this type of point.",
			header: "Confirm Delete Point",
			icon: "fa",
			accept: () => {
				this.FinishDelete();
			},
		});
	}

	FinishDelete() {
		var result = this.PBISService.PointItemDelete(this.SelectedPointsItem.PointsItemID);
		result.subscribe(
			(response) => {
				if (response) {
					this.onRowUnselect(null);
					this.loadPointsItem();

					this.isProcessing = false;
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the point.",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							//this.loadStats();
							//this.loadStudentPBISData();

							this.isProcessing = false;
						},
					});
				}
			},
			(error) => {
				this.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	onSchoolChange(val) {
		this.errorMessage = "";

		this.SchoolID = val;

		this.loadPointsItem();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPointsItem = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPointsItem = null;
	}
	onRowDblClick(PointsItem) {
		this.SelectedPointsItem = PointsItem;

		if (this.IsLoading() == false) {
			this.onEdit();
		}
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		// return this.loading == true || this.SchoolLoading == true || this.isProcessing == true;
		return this.loading == true || this.isProcessing == true;
	}

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	////////////////////////////////////////////
}
